import React, { useEffect, useState } from 'react';
import { ApiService } from '../Services/APIService';
import { StorageUtils } from '../Utils/StorageUtils';

const AdminMetrics = () => {
  const [metrics, setMetrics] = useState(null);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = async () => {
      try {
        const token = StorageUtils.getUserData()?.token || StorageUtils.getToken();
        if (token) {
          ApiService.setAuthToken(token);
        }
        const response = await ApiService.get('admin/metrics');
        setMetrics(response.data.metrics);
      } catch (err) {
        setError('Failed to fetch metrics');
        console.error('Error fetching metrics:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchMetrics();
  }, []);

  if (loading) {
    return (
      <div className="p-4 flex items-center justify-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-danger">
        {error}
      </div>
    );
  }

  return (
    <div className="container py-5">
      <h1 className="mb-4">Admin Dashboard</h1>
      
      <div className="row g-4">
        {/* Users Card */}
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Users</h5>
              <h2 className="card-text text-primary">
                {metrics?.users?.total || 0}
              </h2>
              <p className="text-muted">Total Registered Users</p>
            </div>
          </div>
        </div>

        {/* Summaries Stats Card */}
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Summaries</h5>
              <h2 className="card-text text-primary">
                {metrics?.content?.totalSummaries || 0}
              </h2>
              <p className="text-muted">Total Summaries</p>
            </div>
          </div>
        </div>

        {/* Engagement Card */}
        <div className="col-md-4">
          <div className="card h-100">
            <div className="card-body">
              <h5 className="card-title">Engagement</h5>
              <div className="mb-3">
                <h2 className="card-text text-primary">
                  {metrics?.engagement?.totalClicks || 0}
                </h2>
                <p className="text-muted">Total Clicks</p>
              </div>
              <div>
                <h4 className="text-secondary">
                  {metrics?.engagement?.activeSubscriptions || 0}
                </h4>
                <p className="text-muted">Active Subscriptions</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminMetrics;